import { Button, Icon, Toast, type ToastType } from "@legal-500/legal500-design-system";
import { useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { PageHeader } from "../../../components/PageHeader";
import { ROUTES } from "../../../routes";
import styles from "../UserManagement.module.css";

function UsersLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const [toast, setToast] = useState<{ message: string; type: ToastType } | null>(null);
  const [refetchTrigger, setRefetchTrigger] = useState(0);

  function handleMutationSuccess() {
    setRefetchTrigger(prev => prev + 1);
  }

  const contextListPaths = [ROUTES.users.accountServices, ROUTES.users.staff];

  function handleBackClick() {
    if (window.history.length > 1 && location.key !== "default") {
      navigate(-1);
    } else {
      navigate(ROUTES.users.accountServices);
    }
  }

  function handleCloseToast() {
    setToast(null);
  }

  const isDetailPage = !contextListPaths.includes(location.pathname);

  const listTitles: Record<string, string> = {
    [ROUTES.users.accountServices]: "Account Services Users",
    [ROUTES.users.staff]: "Staff Users",
  };
  const pageTitle = listTitles[location.pathname] ?? "User";

  return (
    <div className={styles.wrapper}>
      <div>
        <PageHeader
          title={pageTitle}
          subtitle={isDetailPage ? undefined : "Manage platform user accounts"}
        >
          {isDetailPage && (
            <Button variant="outlined" color="default" onClick={handleBackClick}>
              <Icon icon="arrow-left" size="small" />
              Back
            </Button>
          )}
        </PageHeader>
      </div>

      <Outlet
        context={{
          toast,
          setToast,
          refetchTrigger,
          onMutationSuccess: handleMutationSuccess,
        }}
      />

      {toast && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={handleCloseToast}
          duration={5000}
        />
      )}
    </div>
  );
}

export default UsersLayout;
